module.exports = "pegasus_template/assets/l_w.png";